module.exports = __webpack_public_path__ + "img/pointcard-btn.b0f98e2e.png";